<template>
    <div class="preview-container">
        <div class="preview-frame" ref="preview-frame-container">
            <div class="frame-container">
                <iframe
                    ref="preview-frame-desktop"
                    id="preview-frame-desktop"
                    :src="`${frameUrl}?_frame=true`"
                    @load="updateScaleDesktop"
                    frameborder="0"
                ></iframe>
            </div>

            <div class="frame-container mobile" ref="preview-frame-container-mobile">
                <iframe
                    ref="preview-frame-mobile"
                    id="preview-frame-mobile"
                    :src="`${frameUrl}?_frame=true&_mobile=true`"
                    @load="updateScaleMobile"
                    frameborder="0"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import {defineComponent} from "vue";

export default defineComponent({
    name: "GalleryFrameComponent",

    props: {
        frameUrl: String,
    },

    data() {
        return {

        };
    },

    computed: {
        desktopFrame(): HTMLIFrameElement {
            return this.$refs["preview-frame-desktop"] as HTMLIFrameElement;
        },

        mobileFrame(): HTMLIFrameElement {
            return this.$refs["preview-frame-mobile"] as HTMLIFrameElement;
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        handleResize() {
            this.updateScaleDesktop();
            this.updateScaleMobile();
        },

        updateFrames(data: Object) {
            const childOrigin = new URL(this.frameUrl as string, location.href).origin;

            if(this.desktopFrame.contentWindow) {
                this.desktopFrame.contentWindow.postMessage({
                    ...data,
                }, childOrigin);
            }

            if(this.mobileFrame.contentWindow) {
                this.mobileFrame.contentWindow.postMessage({
                    ...data,
                }, childOrigin);
            }
        },

        reloadFrames() {
            this.desktopFrame.src += '';
            this.mobileFrame.src += '';
        },

        updateScaleDesktop() {
            const parent = this.$refs["preview-frame-container"] as HTMLElement;

            let parentWidth = parent.offsetWidth - (48 * 2);
            let childWidth = this.desktopFrame.offsetWidth;
            let scale = parentWidth / childWidth;

            this.desktopFrame.style.transform = 'scale(' + scale + ')';

            setTimeout(() => {
                // desktop.contentWindow.scrollTo(0, 0);
            }, 200);
        },

        updateScaleMobile() {
            const parentMobile = this.$refs["preview-frame-container-mobile"] as HTMLElement;

            let parentWidth = parentMobile.offsetWidth;
            let childWidth = this.mobileFrame.offsetWidth;
            let scale = parentWidth / childWidth;

            console.log(this.mobileFrame);

            this.mobileFrame.style.transform = 'scale(' + scale + ')';

            setTimeout(() => {
                // mobile.contentWindow.scrollTo(0, 0);
            }, 200);
        }
    }
});
</script>

<style lang="scss" scoped>
.preview-container {
    position: sticky;
    top: 80px;
    width: 100%;

    .preview-frame {
        width: 100%;

        .frame-container {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background: #fff;
            padding-bottom: calc(112.5% - 48px);
            padding-left: 48px;
            padding-top: 48px;
            border-radius: 8px;

            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            &.mobile {
                width: 30%;
                height: auto;
                padding: 0;
                top: 240px;
                right: 8px;
                left: unset;
                bottom: unset;
                background: none;

                iframe {
                    width: 375px;
                    height: 667px;
                }

                &:after {
                    content: "";
                    position: absolute;
                    top: 10px;
                    left: 25%;
                    border-radius: 10px;
                    width: 50%;
                    height: 18px;
                    background: #000;
                }
            }
        }

        iframe {
            width: 1366px;
            height: 1536px;
            border: 0;
            padding: 0;
            border-radius: 8px;

            transform: scale(0);

            transform-origin: 0 0;
            box-shadow: 0 10px 50px 0 rgba(0,0,0,0.15);
        }

        .desktop-preview {
            width: 100%;
            height: 600px;
        }
    }
}
</style>